import {CATEGORY_ITEMS_SET, CATEGORY_NORMALISE, CATEGORY_SEARCH_ITEM} from "../utils/Constant";

/**
 * @param list
 * @returns {Array}
 */
function buildTree(list) {

  let map = {}, node, roots = [], i;

  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i;
    list[i].items = [];
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    // If the element is not at the root level, add it to its parent array of children.
    if (node.parent_id !== "0") {

      const parent = list[map[node.parent_id]];

      if(parent) {

        node.url = slugArrayToUrl(['catalog', parent.slug, node.slug]);
        list[map[node.parent_id]].items.push(node);

      }

    } else {
      node.url = slugArrayToUrl(['catalog', node.slug]);
      roots.push(node);
    }
  }
  return roots;
}

function slugArrayToUrl(collection = []) {
  return '/' + (collection.join('/'));
}

const categories = function (state = {}, action) {

  switch (action.type) {

    case CATEGORY_NORMALISE:
      let categoryList = [], idBySlug = {};

      const withProducts = action.data.withProducts;


      const categories = withProducts ? action.data.categories : action.data;

      if (categories && Array.isArray(categories)) {

        let productsByCategoryId = {};

        if (withProducts) {
          action.data.products.forEach(product => {
            product.categoryIds && product.categoryIds.forEach(id => {
              if (typeof productsByCategoryId[id] === 'undefined') {
                productsByCategoryId[id] = [];
              }
              productsByCategoryId[id].push({
                id: product.id,
                article: product.article,
                name: product.name,
                thumb: product.thumb,
                category: id,
              });
            });
          });
        }

        categories.forEach(category => {
          categoryList.push(category);
          idBySlug[category.slug] = category.id;
        });

        let tree = buildTree(categoryList)[0] ? buildTree(categoryList)[0]['items'] : [];
        let products = {};

        tree.forEach(category => {

          if (category.items.length) {
            products[category.id] = [];
            category.items.forEach(chidCategory => {

              if(products[category.id] && productsByCategoryId[chidCategory.id]) {
                products[category.id] = [...products[category.id], ...productsByCategoryId[chidCategory.id]];
              }
            });
          } else {
            products[category.id] = productsByCategoryId[category.id];
          }
        });

        return {...state, tree, idBySlug, products, productList: action.data.products};
      }
      return state;
    case CATEGORY_ITEMS_SET:
      let products = {...state.products};
      products[action.data.id] = action.data.items;
      return {...state, products};

    case CATEGORY_SEARCH_ITEM:
      let searchResult = [];

      if(state.productList) {
        const reg = new RegExp(action.data.searchText, "i");//`/${action.data.searchText}/i`;
        searchResult = state.productList.filter((product) => {
          return product.article.search(reg) !== -1 ||  product.name.search(reg) !== -1;
        });
      }
      return {...state, searchResult: {
        searchText: action.data.searchText,
        items: searchResult,
    }};
    default :
      return state;
  }
}
export default categories;
